<template>
    <div class="wrapper about">
      <div class="mycontent">
        <div class="about__image">
            <img :src="`${  Content.img }`" alt="">
        </div>
        <div class="about__content">
            <h2>{{  Content.title }}</h2>
            <p>{{  Content.text }}</p>
        </div>
      </div>
    </div>   
</template>

<script>
let lang = process.env.VUE_APP_LOCALITY;
import Content from "../data/content";

export default {
    name: 'About',
    data: function() {
        return {
            Content: Content[lang].about
        }
    }
}
</script>

<style lang="scss">
.about {
    display: flex;
    flex-wrap: wrap;
    padding: 70px 0;

    @media only screen and (max-width :1023px){
        padding: 50px 0 60px;
    }

    .mycontent {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        justify-content: space-between;

        @media only screen and (max-width :1023px){
            justify-content: center;
        }
    }

    &__content, &__image {
        width: calc(50%);
        text-align: left;
    }

    &__content {

        @media only screen and (max-width :1023px){
            margin-left: auto;
            margin-right: auto;
            margin-bottom: 35px;
            width: 100%;
            text-align: -webkit-center;
        }
    }

    &__image {
        max-widtH: 394px;
        width: 100%;
        height: auto;

        @media only screen and (max-width :1023px){
            margin: 0 auto;
            max-widtH: 290px;
            order: 2;
        }

        img {
            background: #C1DADE;
            border-radius: 30px;
            widtH: 100%;
        }
    }

    h2 {
        font-size: 32px;
        line-height: 130%; /* 41.6px */
        font-family: 'jet-extrabold';
        text-align: left;
        margin-bottom: 14px;
        max-widtH: 394px;

        @media only screen and (max-width :1023px){
            font-size: 20px;
            line-height: 26px;
            text-align: center;
        }
    }

    p {
        font-size: 16px;
        line-height: 150%; /* 24px */
        max-widtH: 394px;
        white-space: break-spaces;

        @media only screen and (max-width :1023px){
            font-size: 14px;
            line-height: 150%; /* 21px */
            text-align: center;
        }
    }



}</style>